import React, { useEffect, useState } from "react";
// import '../assets/stylesheet/layout.scss';
import "../assets/stylesheet/sideNavScroll.scss";
import "@fortawesome/fontawesome-free/css/all.min.css";
import LogoutButton from "../Auth/logout";
import ApiRequest from "../services/apiService";
import baseUrl from "../services/baseUrl";
import { useNavigate } from "react-router-dom";
import handleLogout from "../Auth/logout";
import GetUserData from "../utilities/getUserDetails";
export default function SideNav() {
  // Author: Saksham
  // To clear local and session storage
  const [currentProject, setCurrentProject] = useState(
    localStorage.getItem("projectFilter") || ""
  );
  useEffect(() => {
    setCurrentProject(localStorage.getItem("projectFilter") || "");
  }, []);
  const navigate = useNavigate(); 

  const [userRole, setUserRole] = useState(GetUserData().UserRole);
  // End
  return (
    <aside className="side-nav-wrapper">
      <ul className="side-nav">
        <li className="nav-item">
          <a className="nav-link active" href={"/home"}>
            <span className="menu-icon">
              <i className="fa-solid fa-dashboard"></i>
            </span>{" "}
            <span className="menu-name">Dashboard</span>{" "}
          </a>
        </li>
        <li className="nav-item">
          {currentProject != "" && (currentProject == '1' || currentProject == '4' || currentProject == '5') ? (
            <a className="nav-link" href={`/liveFeeds`}>
              <span className="menu-icon">
                <i className="fa-solid fa-broadcast-tower"></i>
              </span>
              <span className="menu-name">Live Feeds</span>
            </a>
          ) : (
            <a className="nav-link disabled" href={`/liveFeeds`}>
              <span className="menu-icon">
                {/* <i className="fa fa-rss"></i> */}
                <i className="fa-solid fa-broadcast-tower"></i>
              </span>
              <span className="menu-name">Live Feeds</span>
            </a>
          )}
        </li>
        <li className="nav-item">
        {currentProject != "" && (currentProject == '1' || currentProject == '4' || currentProject == '5')? (
            <a className="nav-link" href={`/touchPoint`}>
              <span className="menu-icon">
                <i className="fa-solid fa-map-marker-alt"></i>
              </span>
              <span className="menu-name">Touch Point</span>
            </a>
          ) : (
            <a className="nav-link disabled" href={`/touchPoint`}>
              <span className="menu-icon">
                {/* <i className="fa-solid fa-handshake"></i> */}
                <i className="fa-solid fa-map-marker-alt"></i>
              </span>
              <span className="menu-name">Touch Point</span>
            </a>
          )}
        </li>
        <li className="nav-item">
        {currentProject != "" && (currentProject == '1' || currentProject == '4' || currentProject == '5')? (
            <a className="nav-link" href={`/insights`}>
              <span className="menu-icon">
                <i className="fa-solid fa-chart-line"></i>
              </span>
              <span className="menu-name">Insights</span>
            </a>
          ) : (
            <a className="nav-link disabled" href={`/insights`}>
              <span className="menu-icon">
                {/* <i className="fa-solid fa-lightbulb"></i> */}
                <i className="fa-solid fa-chart-line"></i>
              </span>
              <span className="menu-name">Insights</span>
            </a>
          )}
        </li>
        <li className="nav-item">
          {currentProject != "" ? (
            <a className="nav-link" href={`/request`}>
              <span className="menu-icon">
                {/* <i className="fa fa-paper-plane"></i> */}
                <i className="fa-solid fa-bullhorn"></i>
              </span>
              <span className="menu-name">Request</span>
            </a>
          ) : (
            <a className="nav-link disabled" href={`/request`}>
              <span className="menu-icon">
                <i className="fa-solid fa-bullhorn"></i>
              </span>
              <span className="menu-name">Request</span>
            </a>
          )}
        </li>
        <li className="nav-item">
          {currentProject != "" ? (
            <a className="nav-link" href={`/response`}>
              <span className="menu-icon">
                <i className="fa-solid fa-reply-all"></i>
              </span>
              <span className="menu-name">Response</span>
            </a>
          ) : (
            <a className="nav-link disabled" href={`/response`}>
              <span className="menu-icon">
                <i className="fa-solid fa-reply-all"></i>
              </span>
              <span className="menu-name">Response</span>
            </a>
          )}
        </li>
        <li className="nav-item">
          {currentProject != "" ? (
            <a className="nav-link" href={`/journeyMetrics`}>
              <span className="menu-icon">
                <i className="fa-solid fa-route"></i>
              </span>
              <span className="menu-name">Journey Metrics</span>
            </a>
          ) : (
            <a className="nav-link disabled" href={`/journeyMetrics`}>
              <span className="menu-icon">
                {/* <i className="fa fa-area-chart"></i> */}
                <i className="fa-solid fa-route"></i>
              </span>
              <span className="menu-name">Journey Metrics</span>
            </a>
          )}
        </li>
        <li className="nav-item">
          {userRole == "Admin" ? (
            <a className="nav-link" href={`/userRoleMaster`}>
              <span className="menu-icon">
                <i className="fa-solid fa-user-cog"></i>
              </span>
              <span className="menu-name">User Role Master</span>
            </a>
          ) : (
            ""
          )}
        </li>
        <li className="nav-item">
          {userRole == "Admin" ? (
            <a className="nav-link" href={`/userMaster`}>
              <span className="menu-icon">
                <i className="fa-solid fa-users"></i>
              </span>
              <span className="menu-name">User Master</span>
            </a>
          ) : (
            ""
          )}
        </li>
        <li className="nav-item">
          <a className="nav-link" href={"/selectLanguage"}>
            <span className="menu-icon">
              {/* <i className="fa-solid fa-language"></i> */}
              <i className="fa-solid fa-envelope"></i>
            </span>{" "}
            <span className="menu-name">ConversationPreview</span>{" "}
          </a>
        </li>
        <li className="nav-item">
          <a
            className="nav-link"
            // href={"/login"}
            // onClick={handleLogout}
          >
            <span className="menu-icon">
              <i className="fa-solid fa-sign-out-alt"></i>
            </span>{" "}
            <span className="menu-name">
              <LogoutButton />
            </span>{" "}
          </a>
        </li>
      </ul>
      {/* <ul className="side-nav bottom-nav">
        <li className="nav-item">
          <a className="nav-link" onClick={handleLogout} href={"base_url"}>
            <span className="menu-icon">
              <i className="fa fa-sign-out-alt"></i>
            </span>{" "}
            <span className="menu-name">Log out</span>{" "}
          </a>
        </li>
      </ul> */}
    </aside>
  );
}
